import { useEffect, useState } from 'react'
import Layout from '@/components/layout/layout'
import { Box, Flex, Heading } from '@chakra-ui/react'
import UsersRequestCard from '@/components/cards/users-request-card'
import ModalActionsDashboard from '@/components/modal/modal-actions-dashboard'
import JwtPayload from '@/entities/api/jwt'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '@/store/store'
import Toast from '@/components/elements/toast'
import { fetchContacts } from '@/services/api/customers/contact'
import { selectContactFn, setContactsFn } from '@/store/features/contact'
import { sessionRefrestUpdate } from '@/store/features/state'
import SpinnerLoading from '@/components/elements/spinner'
import NotData from '@/components/elements/not-data'
import ContactEntity from '@/entities/api/users/contact'

const UsersRequest = ({ data }: { data: JwtPayload }) => {
	const [openModal, setopenModal] = useState<Boolean>(false)
	const [isLoading, setIsloading] = useState<boolean>(false)
	const token = useSelector((state: RootState) => state.auth.token)
	const contactRefresh = useSelector(
		(state: RootState) => state.state.contactRefrest
	)
	const contacts = useSelector((state: RootState) => state.contacts.contacts)
	const dispatch = useDispatch<AppDispatch>()

	useEffect(() => {
		const getContacts = async () => {
			try {
				setIsloading(true)

				if (contacts.length === 0) {
					const response = await fetchContacts(token ?? '')
					if (response?.status === 401) {

						dispatch(sessionRefrestUpdate())
						return
					}
					dispatch(setContactsFn(response?.data ?? []))
				}

				setIsloading(false)
			} catch (error) {
				Toast({
					type: 'error',
					message: 'No se pudo obtener las solicitudes de usuarios',
				})
				setIsloading(false)
			}
		}

		getContacts()
	}, [contactRefresh])

	const openModalWithData = (contact: ContactEntity) => {
		dispatch(selectContactFn(contact))
		setopenModal(true)
	}

	return (
		<Layout data={data}>
			{isLoading ? (
				<SpinnerLoading color='black' size='xl' />
			) : (
				<Box w='full' p={{ base: 2, md: 4, xl: 6 }}>
					<Heading
						as='h2'
						color='black'
						fontSize={{ base: '2xl', sm: '3xl' }}
						textAlign={{ base: 'center', md: 'start' }}
						whiteSpace='normal'
						wordBreak='break-word'
						fontWeight='800'
						mb='8'
					>
						Gestion de solicitudes de usuarios
					</Heading>

					<Flex w='full' flexDirection={{ base: 'column', md: 'row' }}>
						<Box
							w={{ base: '100%', md: '50%' }}
							mb={{ base: 4, md: '0' }}
							mr={{ base: 0, md: 2, lg: 4, xl: 6 }}
							borderRadius='md'
							boxShadow='md'
							bg='white'
							p='4'
						>
							<Heading
								as='h3'
								fontSize={{ base: 'xl', md: '2xl' }}
								fontWeight='900'
								color='black'
								whiteSpace='normal'
								wordBreak='break-word'
								textAlign='center'
								mb='4'
							>
								Pendientes
							</Heading>
							{contacts.length > 0 ? (
								contacts.map(
									(contact, index) =>
										contact.status === 'pending' && (
											<UsersRequestCard
											key={index}
												click={openModalWithData}
												contact={contact}
											/>
										)
								)
							) : (
								<NotData />
							)}
						</Box>
						<Box
							w={{ base: '100%', md: '50%' }}
							mt={{ base: 4, md: '0' }}
							ml={{ base: 0, md: 2, lg: 4, xl: 6 }}
							borderRadius='md'
							boxShadow='md'
							bg='white'
							p='4'
						>
							<Heading
								as='h3'
								fontSize={{ base: 'xl', md: '2xl' }}
								fontWeight='900'
								color='black'
								whiteSpace='normal'
								wordBreak='break-word'
								textAlign='center'
								mb='4'
							>
								Revisados
							</Heading>
							{contacts.length > 0 ? (
								contacts.map(
									(contact, index) =>
										contact.status === 'viewed' && (
											<UsersRequestCard key={index} contact={contact} />
										)
								)
							) : (
								<NotData />
							)}
						</Box>
					</Flex>
				</Box>
			)}
			{openModal && (
				<ModalActionsDashboard
					open={openModal}
					close={() => setopenModal(false)}
					action='open-users-request'
				/>
			)}
		</Layout>
	)
}

export default UsersRequest
